import { Button } from '@bpinternal/ui-kit-next'
import { FC } from 'react'
import { showPlanSelectionDialog } from '../components/PlanSelectionDialog'
import { BillingVersion, Plan } from '../types/index'
import managedSaleBackgroundImg from '~/assets/saleEvents/managed-sale.webp'
import { Link } from '@tanstack/react-router'
import { Gift } from 'lucide-react'

type SaleDiscount = {
  promoCode?: string
  couponId?: string
}

type SaleEvent = {
  id: string
  displayName: string
  startDate: Date
  endDate: Date
  dismissible?: boolean
  isElligible: ({
    nextPhasePlan,
    cancellationDate,
    billingVersion,
  }: {
    nextPhasePlan: Plan
    cancelWindowStart: Date
    cancelWindowEnd: Date
    cancellationDate?: Date
    billingVersion?: BillingVersion
  }) => boolean
  planDiscounts: Partial<
    Record<
      Plan,
      {
        percentOff: number
        monthly?: SaleDiscount
        yearly?: SaleDiscount
      }
    >
  >
  Button: FC<{ workspaceId: string }>
  Banner: FC<{ workspaceId: string }>
}

export const SALE_EVENTS: SaleEvent[] = [
  {
    id: 'managed-plan-promo-2026',
    displayName: 'Managed Plan',
    startDate: new Date('2026-02-24T00:00:00'),
    endDate: new Date('2026-03-13T23:59:59'),
    dismissible: true,
    isElligible: ({ nextPhasePlan }) => nextPhasePlan !== 'enterprise',
    planDiscounts: {},
    Button: () => null,
    Banner: () => (
      <div
        className="flex w-full items-center justify-between rounded-xl p-6"
        style={{
          backgroundImage: `url(${managedSaleBackgroundImg})`,
          backgroundSize: 'cover',
          backgroundPosition: '50%',
        }}
      >
        <div className="flex flex-col gap-1 text-white">
          <div className="text-2xl font-semibold">AI agents, built and maintained for you.</div>
          <span className="text-sm font-normal">
            Let our experts build and manage your custom AI solution with our new Managed Plan.
          </span>
        </div>
        <div className="flex items-center gap-3">
          <Button variant="ghost" className="!text-white hover:!bg-white/10" asChild>
            <a href="https://botpress.com/blog/managed-plan" target="_blank" rel="noreferrer">
              Learn more
            </a>
          </Button>
          <Button variant="secondary" className="bg-white !text-black hover:bg-white/90" asChild>
            <a href="https://botpress.com/contact-us/managed-plan" target="_blank" rel="noreferrer">
              Schedule a call
            </a>
          </Button>
        </div>
      </div>
    ),
  },
]
